import { useEffect, useState } from "react";
import { Container, Grid } from "@material-ui/core";

import HeaderClientes from "components/_refactor/headers/clients.js";

import TableCatalogoProdutos from "./components/table-catalogo-produtos";
import FilterCard from "components/_refactor/filter-card";
import AutoCompleteField from "components/_refactor/fields/autocomplete";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import Api from "lib/api/httpRequestHelper";
import useStructureQueries from "hooks/useStructureQueries";
import InputText from "components/_refactor/text/input";

export default function VisualizarCatalogoProdutos() {
  const snackbar = useSnackbar();
  const { getListCatalog } = useStructureQueries();

  const [productsList, setProductsList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingFilters, setIsLoadingFilters] = useState(false);
  const [customFilters, setCustomFilters] = useState(null);
  const [productInfo, setProductInfo] = useState();
  const [selectedLine, setSelectedLine] = useState();
  const [selectedCollection, setSelectedCollection] = useState();
  const [selectedType, setSelectedType] = useState();
  const [selectedBrand, setSelectedBrand] = useState();
  const [descricaoLiteralOptions, setDescricaoLiteralOptions] = useState([]);
  const [selectedDescricaoLiteral, setSelectedDescricaoLiteral] = useState();
  const [isLoadingDescricoes, setIsLoadingDescricoes] = useState(false);

  function truncateText(text, maxLength) {
    if (!text) return "";
    return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
  }

  const handleClearFilters = () => {
    setProductInfo({ name: "", id: "" });
    setSelectedLine({ name: "", id: "" });
    setSelectedCollection({ name: "", id: "" });
    setSelectedType({ name: "", id: "" });
    setSelectedBrand({ name: "", id: "" });
    setSelectedDescricaoLiteral({ name: "", id: "" });
    setProductsList([]);
  };

  const handleSearchProducts = async () => {
    try {
      setIsLoading(true);

      const filterValue =
        typeof productInfo === "string" ? productInfo : productInfo?.name;
      const descricaoLiteralVal = selectedDescricaoLiteral?.name?.trim();

      const searchParams = new URLSearchParams();
      if (filterValue) searchParams.set("filter", filterValue);
      if (selectedLine?.name) searchParams.set("linha", selectedLine.name);
      if (selectedCollection?.name)
        searchParams.set("colecao", selectedCollection.name);
      if (selectedType?.name)
        searchParams.set("tipoProduto", selectedType.name);
      if (selectedBrand?.name) searchParams.set("marca", selectedBrand.name);
      if (descricaoLiteralVal)
        searchParams.set("descricaoLiteral", descricaoLiteralVal);

      const params = searchParams.toString()
        ? `?${searchParams.toString()}`
        : "";

      const response = await Api.get(
        "list-product-catalog",
        "trocasDevolucoes",
        params,
        true,
      );

      const formattedResults = response.Result.ListaProdutos?.map((item) => {
        const photos = item?.Urls?.filter((url) => url !== "").map(
          (url, i) => ({
            fileName: url.split("/").pop().split(".")[0],
            id: item.IdMidias[i],
            productId: item.IdProduto,
            ean: item.Ean,
            url,
          }),
        );

        return {
          code: item.IdProduto,
          description: truncateText(item.DescricaoProduto, 40),
          descriptionFull: item.DescricaoProduto || "",
          line: item.Linha,
          collection: item.Colecao,
          type: item.TipoProduto,
          photos,
        };
      });

      setProductsList(
        formattedResults.filter((item) => item.photos.length > 0),
      );
    } catch (error) {
      snackbar.showMessage(error, { severity: "error" });
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    const getFilters = async () => {
      try {
        setIsLoadingFilters(true);
        const result = await getListCatalog({ page: 0 });
        setCustomFilters(result?.data ?? null);
      } catch (error) {
        snackbar.showMessage(error, { severity: "error" });
      } finally {
        setIsLoadingFilters(false);
      }
    };

    getFilters();
    handleSearchProducts();
  }, []);

  useEffect(() => {
    let cancelled = false;
    setSelectedDescricaoLiteral({ name: "", id: "" });

    const loadDescricoes = async () => {
      try {
        setIsLoadingDescricoes(true);
        const idMarca = selectedBrand?.id;
        const qs =
          idMarca != null && idMarca !== "" && !Number.isNaN(Number(idMarca))
            ? `?idMarca=${encodeURIComponent(idMarca)}`
            : "";

        const response = await Api.get(
          "product-descricao-literal-list",
          "product",
          qs,
          true,
        );

        if (cancelled) return;

        const list = response?.Result;
        setDescricaoLiteralOptions(
          Array.isArray(list)
            ? list.map((text) => ({ name: text, id: text }))
            : [],
        );
      } catch (error) {
        if (!cancelled) {
          setDescricaoLiteralOptions([]);
          snackbar.showMessage(error, { severity: "error" });
        }
      } finally {
        if (!cancelled) setIsLoadingDescricoes(false);
      }
    };

    loadDescricoes();
    return () => {
      cancelled = true;
    };
  }, [selectedBrand?.id]);

  return (
    <>
      <HeaderClientes
        section="Visualzar catálogo de fotos de produtos"
        subsection="Catálogo de Produtos"
      />
      <Container maxWidth={false} style={{ marginTop: "-4.5rem" }}>
        <FilterCard
          handleSearch={handleSearchProducts}
          disabled={isLoading}
          searching={isLoading}
          handleClearFilters={handleClearFilters}
        >
          <Grid item xl={12} xs={12}>
            <InputText
              label="Código/Descrição do produto (Ciclo)"
              value={productInfo}
              onChange={(e) => {
                setProductInfo(e.target.value);
              }}
              disabled={isLoadingFilters}
            />
          </Grid>
          <Grid item xl={6} lg={6} xs={12}>
            <AutoCompleteField
              label="Linha"
              onChange={(e) => setSelectedLine(e)}
              value={selectedLine}
              options={customFilters?.Linha?.map((item) => ({
                name: item,
                id: item,
              }))}
              optionLabelKey="name"
              optionIdKey="id"
              disabled={isLoadingFilters}
            />
          </Grid>
          <Grid item xl={6} lg={6} xs={12}>
            <AutoCompleteField
              label="Coleção/Lançamento"
              onChange={(e) => setSelectedCollection(e)}
              value={selectedCollection}
              options={customFilters?.Colecao?.map((item) => ({
                name: item,
                id: item,
              }))}
              optionLabelKey="name"
              optionIdKey="id"
              disabled={isLoadingFilters}
            />
          </Grid>
          <Grid item xl={6} lg={6} xs={12}>
            <AutoCompleteField
              label="Tipo de produto"
              onChange={(e) => setSelectedType(e)}
              value={selectedType}
              options={customFilters?.TipoProduto?.map((item) => ({
                name: item,
                id: item,
              }))}
              optionLabelKey="name"
              optionIdKey="id"
              disabled={isLoadingFilters}
            />
          </Grid>
          <Grid item xl={6} lg={6} xs={12}>
            <AutoCompleteField
              label="Marca"
              onChange={(e) => setSelectedBrand(e)}
              value={selectedBrand}
              options={[
                { name: "Karsten", id: 1 },
                { name: "Trussardi", id: 2 },
              ]}
              optionLabelKey="name"
              optionIdKey="id"
              disabled={isLoadingFilters}
            />
          </Grid>
          <Grid item xl={6} lg={6} xs={12}>
            <AutoCompleteField
              label="Nome comercial"
              onChange={(e) => setSelectedDescricaoLiteral(e)}
              value={selectedDescricaoLiteral}
              options={descricaoLiteralOptions}
              optionLabelKey="name"
              optionIdKey="id"
              disabled={isLoadingFilters || isLoadingDescricoes}
            />
          </Grid>
        </FilterCard>

        <Grid item xs={12}>
          <TableCatalogoProdutos data={productsList} />
        </Grid>
      </Container>
    </>
  );
}
